import React from 'react';

export default function PulseBlackIcon({ width = 7, height = 9, fill = 'black' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.79965" cy="8.17111" r="0.828944" fill={fill} />
      <circle cx="5.67979" cy="8.05265" r="0.947365" fill={fill} />
      <path
        d="M0 8.99997V0H2.64427C4.30233 -2.33589e-06 4.76403 0.567397 5.09038 1.26088C4.80038 1.19784 4.25973 1.17262 3.09188 1.17262H1.251V4.77329H3.09188C4.25973 4.77329 4.77516 4.74807 5.06516 4.69763C4.47885 5.54873 3.89254 6.00895 2.60014 6.00895H1.251V8.99997H0ZM5.06516 4.69763C5.27199 4.41394 5.37408 3.59079 5.37408 2.96035C5.37408 2.35512 5.29805 1.70219 5.09038 1.26088C5.96039 1.4374 6.63496 2.12816 6.63496 2.96035C6.63496 3.79253 5.94778 4.52111 5.06516 4.69763Z"
        fill={fill}
      />
    </svg>
  );
}
